import Package from './Package';

export default Package;
